import { soadT5Part1DataSchema } from "../../schemas/index.js";
export const soadT5Part1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [],
            teamType: ["soad"],
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            field: "practitioner",
            label: "SOAD name and address",
            hideWarningBanners: true,
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I am a registered medical practitioner appointed for the purposes of Part 4 of the Act (a SOAD).",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I certify that the patient named above has not attained the age of 18 years.",
            ],
        },
        {
            type: "textbox",
            field: "treatment",
            label: "Enter description of treatment or plan of treatment. Indicate clearly if the certificate is only to apply to any or all of the treatment for a specific period",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [part5?.planAuthorisedEct, part5?.timeLimitCertificateDuration]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Treatment plan",
            },
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(a) I certify that this patient is capable of understanding the nature, purpose and likely effects of the above stated treatment or plan of treatment.",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(b) I certify that this patient has consented to that treatment.",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I certify that in my opinion it is appropriate for the above treatment to be given.",
            ],
        },
        {
            type: "textbox",
            field: "reasons",
            label: "My reasons are as below",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part2 = context.previousPartsFormData.find((s) => s.section === "diagnosisAndHistory")?.data;
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [
                        part2?.diagnosis,
                        part2?.assessment,
                        part5?.timeLimitCertificateReason,
                        part5?.interimS61Reasons,
                    ]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Reasons",
            },
            afterLabel: "When giving reasons, please indicate if, in your opinion, disclosure of the reasons to the patient would be likely to cause serious harm to the physical or mental health of the patient, or to that of any other person.",
        },
        {
            type: "branch",
            field: "disclosureHarmful",
            label: "Would disclosure of these reasons to the patient be likely to cause serious harm to the physical or mental health of the patient, or of any other person?",
            afterLabel: "Recording yes adds a warning for anyone viewing this certificate. It does not appear on the certificate itself or the downloaded PDF.",
            branches: [
                { fieldValue: false, label: "No", fields: [], fieldsOwned: [] },
                { fieldValue: true, label: "Yes", fields: [], fieldsOwned: [] },
            ],
        },
    ],
    dataSchema: soadT5Part1DataSchema,
};
export const soadT5V1Base = {
    id: "mha-soad-t5",
    category: "soad",
    version: "1.0",
    status: "active",
    formName: "T5",
    section: "58A(4)",
    parts: [soadT5Part1Template],
    description: "Certificate of consent to treatment and second opinion (patients under 18)",
    extractGenericData: () => ({}),
};
//# sourceMappingURL=soad-t5.js.map